var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { TabGroupStructure } from '../components/TabGroupStructure';
// Utils
import styled from 'styled-components';
export var StyledTabGroup = styled(TabGroupStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-rows: 1fr;\n  width: fit-content;\n  grid-template-columns: ", ";\n  max-width: 800px;\n"], ["\n  display: grid;\n  grid-template-rows: 1fr;\n  width: fit-content;\n  grid-template-columns: ",
    ";\n  max-width: 800px;\n"])), function (_a) {
    var tabsConfig = _a.tabsConfig;
    return tabsConfig ? "repeat(" + tabsConfig.length + ", auto)" : 'auto-fill';
});
var templateObject_1;
//# sourceMappingURL=StyledTabGroup.js.map